import { useEffect, useState } from 'react';

export const debounceTimes = {
  FLAT_FILTERS: 1000,
  TEXT_FILTER: 3000,
};

/**
 * Returns debounced value updates.
 *
 * https://usehooks-ts.com/react-hook/use-debounce
 */
export const useDebounce = <T>(value: T, delay?: number): T => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay || 500);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
};

export default useDebounce;
